"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefundPermissions = void 0;
var constants_1 = require("@hobt/constants");
exports.RefundPermissions = {
    Delete: {
        modules: [constants_1.Module.Claim],
        roles: [constants_1.UserRole.BusinessUser, constants_1.UserRole.Clerk, constants_1.UserRole.MasterUser],
    },
    Read: {
        modules: [constants_1.Module.Claim],
        roles: [constants_1.UserRole.BusinessUser, constants_1.UserRole.Clerk, constants_1.UserRole.MasterUser, constants_1.UserRole.ReadOnly],
    },
    ReadPrefill: {
        modules: [constants_1.Module.Claim],
        roles: [constants_1.UserRole.BusinessUser, constants_1.UserRole.Clerk, constants_1.UserRole.MasterUser, constants_1.UserRole.ReadOnly],
    },
    Update: {
        modules: [constants_1.Module.Claim],
        roles: [constants_1.UserRole.BusinessUser, constants_1.UserRole.Clerk, constants_1.UserRole.MasterUser],
    },
};
